import React, { useCallback, useEffect, useState } from "react";
import "./OrderDetailsUpdated.css";
import SideOrderDetails from "./SharedModule/SideOrderDetails";
import HeadOrderDetails from "./SharedModule/HeadOrderDetails";
import axios from "axios";
import { useID } from "./SharedModule/IdContext";
import NotFound from "./SharedModule/NotFound";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ServicesCategoryModal from "./OrderDetailsModals/ServicesCategoryModal";
import SubCategoriesModal from "./OrderDetailsModals/SubCategoriesModal";
import CheckModal from "./OrderDetailsModals/CheckModal";
import CheckOfferDetailsModal from "./OrderDetailsModals/CheckOfferDetailsModal";
import TireChangeModal from "./OrderDetailsModals/TireChangeModal";
import AvailableTyresModal from "./OrderDetailsModals/AvailableTyresModal";
import OilChangeModal from "./OrderDetailsModals/OilChangeModal";
import BatteryChangeModal from "./OrderDetailsModals/BatteryChangeModal";
import DeleteModal from "./Modals/DeleteModal";
import { useSelector } from "react-redux";
import { Cancel } from "@mui/icons-material";
import { formatNumber } from "../hooks/formatNumber";
import OrderPricingSummary from "./OrderPricingSummary/OrderPricingSummary";

export default function OrderDetailsUpdated() {

  const { user } = useSelector((state) => state.auth);

  console.log(user);

  const token = user?.token;

  const baseUrl = "https://estbn.com/EstbnNew/public";

  const [isServicesCategoryOpen, setIsServicesCategoryOpen] = useState(false);

  const [orderDetails, setOrderDetails] = useState([]);

  const [mainCategories, setMainCategories] = useState([]);

  const [subCategories, setSubCategories] = useState([]);

  const [subCategoriesServices, setSubCategoriesServices] = useState([]);

  const [IssubCategories, setIsSubCategories] = useState(false);

  const [checkDetails, setCheckDetails] = useState([]);

  const [IsCheckModal, setIsCheckModal] = useState(false);

  const [isCheckOfferDetailsModalOpen, setIsCheckOfferDetailsModalOpen] =
    useState(false);

  const [offerDetails, setOfferDetails] = useState([]);

  const [tyreDetails, setTyreDetails] = useState([]);

  const [tyreHeightId, setTyreHeightId] = useState("");

  const [tyreWidthId, setTyreWidthId] = useState("");

  const [tyreRimId, setTyreRimId] = useState("");

  const [tyreTypeId, setTyreTypeId] = useState(null);

  const [tyreBrandId, setTyreBrandId] = useState("");

  const [tyreServiceId, setTyreServiceId] = useState(null);

  const [oilServiceId, setOilServiceId] = useState(null);

  const [AvailableTyresDetails, setAvailableTyresDetails] = useState([]);

  const [selectedTyreId, setSelectedTyreId] = useState(null);

  const [oldOut, setOldOut] = useState(0);

  const [isTireChangeModalOpen, setIsTireChangeModalOpen] = useState(false);

  const [isAvailableTyresModalOpen, setIsAvailableTyresModalOpen] =
    useState(false);

  const [changeOilDetails, setChangeOilDetails] = useState([]);

  const [isOilChangeModalOpen, setIsOilChangeModalOpen] = useState(false);

  const [brandId, setBrandId] = useState("");

  const [changeOilViscosityDetails, setChangeOilViscosityDetails] = useState(
    []
  );

  const [viscosityId, setViscosityId] = useState("");

  const [changeOilVolumeDetails, setChangeOilVolumeDetails] = useState([]);

  const [filterDetails, setFilterDetails] = useState([]);

  const [volumeId, setVolumeId] = useState("");

  const [carOilId, setCarOilId] = useState(null);

  const [filterId, setFilterId] = useState(null);

  const [isBatteryChangeModalOpen, setIsBatteryChangeModalOpen] =
    useState(false);

  const [changeBatteryDetails, setChangeBatteryDetails] = useState([]);

  const [batteryServiceId, setBatteryServiceId] = useState(null);

  const [batteryTypeId, setBatteryTypeId] = useState("");

  const [batteryAmpereId, setBatteryAmpereId] = useState("");

  const [changeBatteryAmperesDetails, setChangeBatteryAmperesDetails] =
    useState([]);

  const [batteryBrandId, setBatteryBrandId] = useState("");

  const [changeBatteryBrandsDetails, setChangeBatteryBrandsDetails] = useState(
    []
  );

  const [specificBattery, setSpecificBattery] = useState([]);

  const [order, setOrder] = useState([]);

  const [openCategory, setOpenCategory] = useState(null);

  const [number, setNumber] = useState(1);

  const [isEdit, setIsEdit] = useState(true);

  const [catId, setCatIdToDelete] = useState(null);

  const [dataFetched, setDataFetched] = useState({
    viscosity: false,
    volume: false,
    carOil: false,
    battery: false,
  });

  const [selectedCheckService, setSelectedCheckService] = useState([]);
  const [selectedCheckOffer, setSelectedCheckOffer] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalOfferPrice, setTotalOfferPrice] = useState(0);
  const [serviceIds, setServiceIds] = useState([]);
  const [offerId, setOfferId] = useState("");
  const [checkedOffer, setCheckedOffer] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const increment = useCallback(() => {
    setNumber((prev) => prev + 1);
  }, []);

  const decrement = useCallback(() => {
    setNumber((prev) => (prev > 1 ? prev - 1 : prev));
  }, []);

  const toggleServicesCategoryModal = () => {
    setIsEdit(false);
    getMainCategories();
    setIsServicesCategoryOpen(!isServicesCategoryOpen);
    setIsSubCategories(false);
  };

  const toggleSubCategories = () => {
    setIsSubCategories(!IssubCategories);
    getMainCategories();
    setIsServicesCategoryOpen(false);
    setIsCheckModal(false);
    setIsTireChangeModalOpen(false);
    setIsOilChangeModalOpen(false);
    setIsBatteryChangeModalOpen(false);
  };

  const toggleSaveSubCategories = () => {
    setIsSubCategories(!IssubCategories);
    getMainCategories();
    setIsServicesCategoryOpen(true);
    setIsCheckModal(false);
    setIsTireChangeModalOpen(false);
    setIsOilChangeModalOpen(false);
    setIsBatteryChangeModalOpen(false);
  };

  const toggleCheckModal = () => {
    setIsCheckModal(!IsCheckModal);
    getSubCategories();
    setIsSubCategories(true);
    setIsServicesCategoryOpen(false);
  };

  const toggleCheckOfferDetailsModal = () => {
    setIsCheckOfferDetailsModalOpen(!isCheckOfferDetailsModalOpen);
  };

  const toggleTireChangeModal = () => {
    setIsTireChangeModalOpen(!isTireChangeModalOpen);
    setIsAvailableTyresModalOpen(false);
  };

  const toggleCategoryDetails = (categoryId) => {
    setOpenCategory(openCategory === categoryId ? null : categoryId);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setCatIdToDelete(null);
  };

  const { id } = useParams();

  const { setId } = useID();

  const getOrderDetails = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/portal/orders/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.order);
      if (order !== response.data.data.order) {
        setOrder(response.data.data.order);
      }
      console.log(response.data.data.offer);
      if (orderDetails !== response.data.data.order.categories) {
        setOrderDetails(response.data.data.order.categories);
        console.log(response.data.data.order.categories);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getMainCategories = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/portal/door_step/${id}/categories`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data.categories);
      if (mainCategories !== response.data.data.categories) {
        setMainCategories(response.data.data.categories);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getSubCategories = async (slug) => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/portal/door_step/${id}/categories/${slug}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data.service_category);
      if (subCategories !== response.data.data.service_category) {
        setSubCategories(response.data.data.service_category);
      }
      console.log(response.data.data.service_category.subcategories);
      if (
        subCategoriesServices !==
        response.data.data.service_category.subcategories
      ) {
        setSubCategoriesServices(
          response.data.data.service_category.subcategories
        );
      }
      setIsSubCategories(true);
      setIsServicesCategoryOpen(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getCheckDetails = async (slug) => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/portal/door_step/${id}/categories/${slug}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data.service_category);
      if (checkDetails !== response.data.data.service_category) {
        setCheckDetails(response.data.data.service_category);
      }
      setIsCheckModal(true);
      setIsSubCategories(false);
      setIsServicesCategoryOpen(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getCheckOfferDetails = async (id) => {
    try {
      let response = await axios.get(`${baseUrl}/api/door_step_offers/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.offer);
      if (offerDetails !== response.data.data.offer) {
        setOfferDetails(response.data.data.offer);
      }
      setIsCheckOfferDetailsModalOpen(true);
    } catch (error) {
      console.log(error);
    }
  };

  const getTyreDetails = async (id) => {
    setTyreServiceId(id);
    try {
      let response = await axios.get(`${baseUrl}/api/filter_tyre_data`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (isEdit === true) {
        getOrderTyreService();
      } else {
        getOrderTyreService();
        setIsTireChangeModalOpen(true);
        setIsSubCategories(false);
        setIsServicesCategoryOpen(false);
      }
      console.log(response.data.data);
      if (tyreDetails !== response.data.data) {
        setTyreDetails(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAvailableTyres = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_tyre_data?height=${tyreHeightId}&width=${tyreWidthId}&rim_diameter=${tyreRimId}&type_id=${tyreTypeId}&brand_id=${tyreBrandId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data.tyres);
      if (AvailableTyresDetails !== response.data.data.tyres) {
        setAvailableTyresDetails(response.data.data.tyres);
      }
      setIsTireChangeModalOpen(!isTireChangeModalOpen);
      setIsAvailableTyresModalOpen(true);
      setIsTireChangeModalOpen(false);
      setIsSubCategories(false);
      setIsServicesCategoryOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getOrderTyreService = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/filter_tyre_data/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.tyres);
      setTyreBrandId(response.data.data.tyres[0].brand?.id);
      setTyreHeightId(response.data.data.tyres[0].dimension?.height);
      setTyreWidthId(response.data.data.tyres[0].dimension?.width);
      setTyreRimId(response.data.data.tyres[0].dimension?.rim_diameter);
      setTyreTypeId(response.data.data.tyres[0].type?.id);
      if (isEdit === true) {
        getAvailableTyres();
      } else {
        return;
      }
      // const selectedtyre = response.data.data.tyres.filter(
      //   (item) => item.selected === true
      // );
      // setSelectedTyreId(selectedtyre.id);
      // setNumber(selectedtyre.count)
      // setOldOut(selectedtyre.old_out);
    } catch (error) {
      console.log(error);
    }
  };

  const getfilterDetails = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_filter_data/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data);
      if (filterDetails !== response.data.data) {
        setFilterDetails(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOrderFilterService = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_filter_data/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data.filters);
      const selectedFilter = response.data.data.filters?.find(
        (item) => item.selected === true
      );
      console.log(selectedFilter);
      setFilterId(selectedFilter?.id);
    } catch (error) {
      console.log(error);
    }
  };

  const getOilDetails = async (id) => {
    setOilServiceId(id);
    try {
      let response = await axios.get(`${baseUrl}/api/filter_oil_data`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data);
      if (changeOilDetails !== response.data.data) {
        setChangeOilDetails(response.data.data);
      }
      getOrderOilService();
      getOrderFilterService();
      setIsOilChangeModalOpen(true);
      getfilterDetails();
      setIsSubCategories(false);
      setIsServicesCategoryOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getOilViscosityDetails = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_oil_data?brand_id=${brandId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data);
      if (changeOilViscosityDetails !== response.data.data) {
        setChangeOilViscosityDetails(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOilVolumeDetails = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_oil_data?viscosity_id=${viscosityId}&brand_id=${brandId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data);
      if (changeOilVolumeDetails !== response.data.data) {
        setChangeOilVolumeDetails(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCarOilDetails = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_oil_data?viscosity_id=${viscosityId}&brand_id=${brandId}&volume_id=${volumeId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data.car_oil?.id);
      if (carOilId !== response.data.data.car_oil?.id) {
        setCarOilId(response.data.data.car_oil?.id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOrderOilService = async () => {
    try {
      let response = await axios.get(`${baseUrl}/api/filter_oil_data/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data.data.car_oil);
      setBrandId(response.data.data.car_oil?.brand?.id);
      setViscosityId(response.data.data.car_oil?.viscosity?.id);
      setVolumeId(response.data.data.car_oil?.volume?.id);
    } catch (error) {
      console.log(error);
    }
  };

  const getBatteryDetails = async (id) => {
    setBatteryServiceId(id);
    try {
      let response = await axios.get(`${baseUrl}/api/filter_battery_data`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      getOrderBatteryService();
      console.log(response.data.data);
      if (changeBatteryDetails !== response.data.data) {
        setChangeBatteryDetails(response.data.data);
      }
      setIsBatteryChangeModalOpen(true);
      setIsSubCategories(false);
      setIsServicesCategoryOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getBatteryAmperesDetails = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_battery_data?type_id=${batteryTypeId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data);
      if (changeBatteryAmperesDetails !== response.data.data) {
        setChangeBatteryAmperesDetails(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getBatteryBrandsDetails = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_battery_data?type_id=${batteryTypeId}&ampere_id=${batteryAmpereId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data);
      if (changeBatteryBrandsDetails !== response.data.data) {
        setChangeBatteryBrandsDetails(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getBrandOfTheBattery = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_battery_data?type_id=${batteryTypeId}&ampere_id=${batteryAmpereId}&brand_id=${batteryBrandId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data);
      if (specificBattery !== response.data.data) {
        setSpecificBattery(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getOrderBatteryService = async () => {
    try {
      let response = await axios.get(
        `${baseUrl}/api/filter_battery_data/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response.data.data.battery);
      setBatteryBrandId(response.data.data.battery?.brand?.id);
      setBatteryTypeId(response.data.data.battery?.type?.id);
      setBatteryAmpereId(response.data.data.battery?.ampere?.id);
    } catch (error) {
      console.log(error);
    }
  };

  const createBatteryService = async () => {
    const batteryData = new FormData();
    batteryData.append("service_id", batteryServiceId);
    batteryData.append("battery_id", specificBattery?.battery?.id);

    try {
      let response = await axios.post(
        `${baseUrl}/api/portal/orders/${id}/change_battery`,
        batteryData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      getOrderDetails();
      if (isEdit === true) {
        setIsBatteryChangeModalOpen(false);
        toast.success("Battery Service Updated Successfully", {
          autoClose: 3000,
        });
      } else {
        setIsBatteryChangeModalOpen(false);
        setIsSubCategories(true);
        toast.success("Battery Service Added Successfully", {
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const createTyreService = async () => {
    if (!selectedTyreId || oldOut === null || number <= 0) {
      alert(
        "Please select a valid tyre, old tyres option, and tyre count before saving."
      );
      return;
    }

    const TyreData = new FormData();
    TyreData.append("tyre_id", selectedTyreId);
    TyreData.append("count", number);
    TyreData.append("old_out", oldOut);
    TyreData.append("service_id", tyreServiceId);

    try {
      let response = await axios.post(
        `${baseUrl}/api/portal/orders/${id}/change_tyre`,
        TyreData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      getOrderDetails();
      if (isEdit === true) {
        toast.success("Tyre Service Updated Successfully", { autoClose: 3000 });
        setIsAvailableTyresModalOpen(false);
      } else {
        toast.success("Tyre Service Added Successfully", { autoClose: 3000 });
        setIsAvailableTyresModalOpen(false);
        setIsSubCategories(true);
      }
    } catch (error) {
      toast.error("Failed to add tyre service. Please try again.");
      console.log(error.message);
    }
  };

  const createOilService = async () => {
    const oilData = {
      oil_id: carOilId ?? null,
      filter_id: filterId ?? null,
      service_id: oilServiceId,
    };

    try {
      let response = await axios.post(
        `${baseUrl}/api/portal/orders/${id}/select_oil_filter`,
        JSON.stringify(oilData),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      getOrderDetails();
      if (isEdit === true) {
        setIsOilChangeModalOpen(false);
        toast.success("Oil Service Updated Successfully", { autoClose: 3000 });
      } else {
        setIsOilChangeModalOpen(false);
        setIsSubCategories(true);
        toast.success("Oil Service Added Successfully", { autoClose: 3000 });
      }
    } catch (error) {
      toast.error("Failed to add oil service. Please try again.");
      console.log(error.message);
    }
  };

  const ChangeCheckService = (checked, id, price) => {
    console.log("Service ID:", id, "Checked:", checked);
    if (checkedOffer) {
      toast.warn("Please Unselect The Offer, من فضلك قم بالغاء اختيار العرض ");
      return;
    }
    setServiceIds((prev) => {
      if (checked) {
        return [...prev, id];
      } else {
        return prev.filter((serviceId) => serviceId !== id);
      }
    });

    setSelectedCheckService((prevSelected) => {
      let updatedSelected;

      if (checked) {
        updatedSelected = [...prevSelected, { id, price: +price }];
      } else {
        updatedSelected = prevSelected.filter((service) => service.id !== id);
      }

      console.log("Updated Selected Services:", updatedSelected);

      const newTotal = updatedSelected.reduce(
        (sum, service) => sum + service.price,
        0
      );
      console.log("New Total Service Price:", newTotal);

      setTotalPrice(newTotal);
      return updatedSelected;
    });
  };

  const ChangeOfferPrice = (checked, id, price) => {
    console.log("Offer ID:", id, "Checked:", checked);
    if (checked) {
      setSelectedCheckService([]);
      setTotalPrice(0);
      setServiceIds([]);
    }
    setOfferId((prev) => (checked ? id : null));

    setCheckedOffer(checked);

    setSelectedCheckOffer((prevSelected) => {
      let updatedSelected;

      if (checked) {
        updatedSelected = [{ id, price: +price }];
      } else {
        updatedSelected = [];
      }

      console.log("Updated Offers:", updatedSelected);

      const newTotal = updatedSelected.reduce(
        (sum, offer) => sum + offer.price,
        0
      );
      console.log("New Total Offer Price:", newTotal);

      setTotalOfferPrice(newTotal);
      return updatedSelected;
    });
  };

  const handleCheckService = async () => {
    try {
      const response = await axios.post(
        `https://estbn.com/MobileAppBackend/public/api/portal/orders/${id}/add_service`,
        {
          service_ids: serviceIds,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      getSubCategories();
      getOrderDetails();
      if (isEdit === true) {
        setIsCheckModal(false);
        toast.success("Service Updated Successfully", { autoClose: 3000 });
      } else {
        toggleCheckModal();
        toast.success(response.data.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.errors.message);
    }
  };

  const handleCheckOffer = async () => {
    try {
      const response = await axios.post(
        `https://estbn.com/MobileAppBackend/public/api/portal/orders/${id}/add_offer`,
        {
          offer_id: offerId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(response);
      getSubCategories();
      getOrderDetails();
      if (isEdit === true) {
        setIsCheckModal(false);
        toast.success("Service Updated Successfully", {
          autoClose: 3000,
        });
      } else {
        toggleCheckModal();
        toast.success(response.data.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  const deleteSubCategory = async () => {
    try {
      let response = await axios.delete(
        `${baseUrl}/api/portal/orders/${id}/delete_category/${catId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.warning("Services Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getOrderDetails();
    } catch (error) {
      toast.error("Failed To Delete This Category.");
      console.log(error.message);
    }
  };

  const navigate = useNavigate();

  function goToActivity() {
    navigate(`/Activity/${id}`);
  }

  const goToComments = () => {
    navigate(`/comments/${id}`);
  };

  const goToCheckBefore = () => {
    navigate(`/checkBefore/${id}`);
  };

  const goToCheckAfter = () => {
    navigate(`/checkAfter/${id}`);
  };

  const goToReviews = () => {
    navigate(`/ordReviews/${id}`);
  };

  const [selectedMaintainance, setSelectedMaintainance] = useState(null);
  const [showMaintainanceModal, setShowMaintainanceModal] = useState(false);

  const openMaintainanceModal = (subcategory) => {
    setSelectedMaintainance(subcategory);
    setShowMaintainanceModal(true);
  };

  useEffect(() => {
    if (id && id !== setId) {
      setId(id);
    }
  }, [id, setId]);

  useEffect(() => {
    getOrderDetails();
    getMainCategories();
    getSubCategories();
    if (brandId) getOilViscosityDetails();
    if (viscosityId) getOilVolumeDetails();
    if (volumeId) getCarOilDetails();
    if (batteryTypeId) getBatteryAmperesDetails();
    if (batteryAmpereId) getBatteryBrandsDetails();
    if (batteryBrandId) getBrandOfTheBattery();
  }, [
    isEdit,
    id,
    brandId,
    viscosityId,
    volumeId,
    batteryTypeId,
    batteryAmpereId,
    batteryBrandId,
    subCategories,
    subCategoriesServices,
  ]);

  useEffect(() => {
    if (!dataFetched.viscosity && brandId) {
      getOilViscosityDetails();
      setDataFetched((prev) => ({ ...prev, viscosity: true }));
    }
    if (!dataFetched.volume && viscosityId) {
      getOilVolumeDetails();
      setDataFetched((prev) => ({ ...prev, volume: true }));
    }
    if (!dataFetched.carOil && volumeId) {
      getCarOilDetails();
      setDataFetched((prev) => ({ ...prev, carOil: true }));
    }
    if (!dataFetched.battery && batteryTypeId) {
      getBatteryAmperesDetails();
      setDataFetched((prev) => ({ ...prev, battery: true }));
    }
  }, [brandId, viscosityId, volumeId, batteryTypeId, dataFetched]);

  useEffect(() => {
    if (IsCheckModal && checkDetails?.services?.length > 0) {
      console.log("checkServices", checkDetails);

      const preselectedServices = checkDetails.services
        .filter((service) => service.selected)
        .map((service) => ({ id: service.id, price: +service.price || 0 }));

      setSelectedCheckService(preselectedServices);

      const initialTotal = preselectedServices.reduce(
        (sum, service) => sum + service.price,
        0
      );
      setTotalPrice(initialTotal);
    }

    if (IsCheckModal && checkDetails?.offers?.length > 0) {
      console.log("checkOffer", checkDetails?.offers);

      const preselectedOffer = checkDetails.offers
        .filter((offer) => offer.selected)
        .map((offer) => ({ id: offer.id, price: +offer.offer_price || 0 }));

      console.log("Preselected Offers:", preselectedOffer);

      setSelectedCheckOffer(preselectedOffer);

      const initialTotalOffer = preselectedOffer.reduce(
        (sum, offer) => sum + offer.price,
        0
      );
      console.log("Initial Offer Total:", initialTotalOffer);

      setTotalOfferPrice(initialTotalOffer);
      setCheckedOffer(preselectedOffer.length > 0);
    }

    if (!IsCheckModal) {
      setCheckedOffer(false);
      setTotalOfferPrice(0);
    }
  }, [IsCheckModal, checkDetails]);

  return (
    <>
      {/* maintenance modal */}
      {showMaintainanceModal && selectedMaintainance && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            {/* header */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className=" fw-semiBold">{selectedMaintainance.name}</h5>
              <Cancel
                className=" cursor"
                onClick={() => setShowMaintainanceModal(false)}
              />
            </div>
            {/* offer name */}
            <div className="border rounded p-3 mb-3 bg-light d-flex justify-content-between align-items-center">
              <p className="my-0 fw-semibold fs-5">
                {new Intl.NumberFormat("ar-EG").format(
                  selectedMaintainance.selected_price_plan_bundle?.final_price,
                )}{" "}
                ج.م
              </p>
              <div>
                <p className="fw-bold my-0">
                  {selectedMaintainance.selected_price_plan_bundle?.name}
                </p>
                <p className="my-0">
                  {selectedMaintainance.selected_price_plan_bundle?.description}
                </p>
              </div>
            </div>
            {/* items */}
            <p className=" fw-semibold text-muted my-0">
              تفاصيل الخدمات والمنتجات
            </p>
            {selectedMaintainance.items.map((item) => (
              <div key={item.id} className="service-box mb-2 py-2 rounded">
                {/* عنوان الخدمة */}
                <div className="d-flex justify-content-end align-items-center mb-2">
                  <p className="fw-semibold mb-0 mx-2">{item.service_name}</p>
                  <span className="check-icon">✔</span>
                </div>
                {/* لو فيه product */}
                {item.variation ? (
                  <div className="service-details fw-semibold">
                    <p className="mb-1">
                      {item.variation?.name} :{" "}
                      <span className="text-muted">المنتج</span>{" "}
                    </p>
                    <p className="mb-1">
                      <span className="text-muted">الكمية : </span>{" "}
                      {item.quantity}
                    </p>
                    {/* المواصفات */}
                    {item.variation?.selected_properties?.length > 0 && (
                      <div className="mt-1">
                        {item.variation.selected_properties.map((prop) => (
                          <div className="d-flex justify-content-end align-items-center">
                            <p className="me-1"> {prop.value} </p>
                            <span className="text-muted">
                              {" "}
                              : {prop.property_name}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                    <p className="mb-0">
                      <span className="text-muted"> سعر المنتج : </span>{" "}
                      {formatNumber(item.variation?.current_price)} ج.م
                    </p>
                    <p className="mb-0">
                      <span className="text-muted"> سعر الخدمة : </span>{" "}
                      {formatNumber(item.service_price_total)} ج.م
                    </p>
                  </div>
                ) : (
                  <div className="service-details fw-semibold">
                    <p className="mb-0 ">
                      <span className="text-muted"> سعر الخدمة : </span>{" "}
                      {formatNumber(
                        item.service_price_total || item.final_price,
                      )}{" "}
                      ج.م
                    </p>
                  </div>
                )}
              </div>
            ))}
            {/* total */}
            <div className="mt-3 fw-bold bg-light d-flex justify-content-between align-items-center p-3 rounded-3">
              <p className="my-0">
                {new Intl.NumberFormat("ar-EG").format(
                  selectedMaintainance.price,
                )}{" "}
                ج.م
              </p>
              <p className="my-0"> : الاجمالي </p>
            </div>
          </div>
        </div>
      )}
      {/* delete subCategory */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this category?"}
        deleteFunction={deleteSubCategory}
      />
      {/* Select Category  */}
      <ServicesCategoryModal
        isServicesCategoryOpen={isServicesCategoryOpen}
        toggleServicesCategoryModal={toggleServicesCategoryModal}
        mainCategories={mainCategories}
        getSubCategories={getSubCategories}
        baseUrl={baseUrl}
        setIsEdit={setIsEdit}
      />
      {/* subCategoryModa  */}
      <SubCategoriesModal
        IssubCategories={IssubCategories}
        toggleServicesCategoryModal={toggleServicesCategoryModal}
        subCategories={subCategories}
        baseUrl={baseUrl}
        subCategoriesServices={subCategoriesServices}
        getCheckDetails={getCheckDetails}
        getOilDetails={getOilDetails}
        getBatteryDetails={getBatteryDetails}
        getTyreDetails={getTyreDetails}
        toggleSaveSubCategories={toggleSaveSubCategories}
      />
      {/* CheckModal  */}
      <CheckModal
        IsCheckModal={IsCheckModal}
        checkDetails={checkDetails}
        baseUrl={baseUrl}
        isEdit={isEdit}
        setIsCheckModal={setIsCheckModal}
        toggleSubCategories={toggleSubCategories}
        selectedCheckService={selectedCheckService}
        ChangeCheckService={ChangeCheckService}
        selectedCheckOffer={selectedCheckOffer}
        setCheckedOffer={setCheckedOffer}
        ChangeOfferPrice={ChangeOfferPrice}
        totalPrice={totalPrice}
        totalOfferPrice={totalOfferPrice}
        checkedOffer={checkedOffer}
        handleCheckOffer={handleCheckOffer}
        handleCheckService={handleCheckService}
        getCheckOfferDetails={getCheckOfferDetails}
      />
      {/* CheckOfferDetailseModal  */}
      <CheckOfferDetailsModal
        isCheckOfferDetailsModalOpen={isCheckOfferDetailsModalOpen}
        offerDetails={offerDetails}
        checkDetails={checkDetails}
        toggleCheckOfferDetailsModal={toggleCheckOfferDetailsModal}
      />
      {/* TireChangeModal  */}
      <TireChangeModal
        isTireChangeModalOpen={isTireChangeModalOpen}
        tyreDetails={tyreDetails}
        tyreRimId={tyreRimId}
        setTyreRimId={setTyreRimId}
        tyreHeightId={tyreHeightId}
        setTyreHeightId={setTyreHeightId}
        tyreWidthId={tyreWidthId}
        setTyreWidthId={setTyreWidthId}
        tyreTypeId={tyreTypeId}
        setTyreTypeId={setTyreTypeId}
        tyreBrandId={tyreBrandId}
        setTyreBrandId={setTyreBrandId}
        getAvailableTyres={getAvailableTyres}
        isEdit={isEdit}
        toggleSubCategories={toggleSubCategories}
        setIsTireChangeModalOpen={setIsTireChangeModalOpen}
      />
      {/* AvailableTyreChangeModal  */}
      <AvailableTyresModal
        isAvailableTyresModalOpen={isAvailableTyresModalOpen}
        AvailableTyresDetails={AvailableTyresDetails}
        number={number}
        setNumber={setNumber}
        decrement={decrement}
        increment={increment}
        setOldOut={setOldOut}
        oldOut={oldOut}
        setSelectedTyreId={setSelectedTyreId}
        createTyreService={createTyreService}
        toggleTireChangeModal={toggleTireChangeModal}
        baseUrl={baseUrl}
      />
      {/* oilChangeModal  */}
      <OilChangeModal
        isOilChangeModalOpen={isOilChangeModalOpen}
        setIsOilChangeModalOpen={setIsOilChangeModalOpen}
        changeOilDetails={changeOilDetails}
        changeOilViscosityDetails={changeOilViscosityDetails}
        changeOilVolumeDetails={changeOilVolumeDetails}
        filterDetails={filterDetails}
        subCategoriesServices={subCategoriesServices}
        brandId={brandId}
        setBrandId={setBrandId}
        viscosityId={viscosityId}
        setViscosityId={setViscosityId}
        volumeId={volumeId}
        setVolumeId={setVolumeId}
        filterId={filterId}
        setFilterId={setFilterId}
        isEdit={isEdit}
        toggleSubCategories={toggleSubCategories}
        createOilService={createOilService}
      />
      {/* batteryChangeModal  */}
      <BatteryChangeModal
        isBatteryChangeModalOpen={isBatteryChangeModalOpen}
        setIsBatteryChangeModalOpen={setIsBatteryChangeModalOpen}
        changeBatteryDetails={changeBatteryDetails}
        changeBatteryAmperesDetails={changeBatteryAmperesDetails}
        changeBatteryBrandsDetails={changeBatteryBrandsDetails}
        specificBattery={specificBattery}
        subCategoriesServices={subCategoriesServices}
        batteryTypeId={batteryTypeId}
        setBatteryTypeId={setBatteryTypeId}
        batteryAmpereId={batteryAmpereId}
        setBatteryAmpereId={setBatteryAmpereId}
        batteryBrandId={batteryBrandId}
        setBatteryBrandId={setBatteryBrandId}
        isEdit={isEdit}
        toggleSubCategories={toggleSubCategories}
        createBatteryService={createBatteryService}
      />
      {/* Head Details */}
      <HeadOrderDetails />
      {/* Details Filteration */}
      <div className="details-filter mx-4">
        <button className="btn bg-black text-white">Order Details</button>
        <button onClick={goToActivity} className="btn">
          Activity logs
        </button>
        <button className="btn" onClick={goToComments}>
          Client Comments
        </button>
        {user.operator.roles[0].name === "outbound-agent" ? (
          ""
        ) : (
          <>
            <button className="btn" onClick={goToCheckBefore}>
              Check Body Before
            </button>
            <button className="btn" onClick={goToCheckAfter}>
              Check Body After
            </button>
          </>
        )}
        <button className="btn" onClick={goToReviews}>
          Reviews
        </button>
      </div>
      {/* Service Details */}
      <div className="service-details">
        <div className="row m-4 justify-content-between">
          <div className="  col-sm-12 col-md-8 border border-1 rounded-2">
            {/* Add Services Details */}
            <div className="px-2 py-3 border-bottom border-2">
              <h3 className="pt-2">Order Details</h3>
            </div>
            {/* All Service Details */}
            <div className="allDetails">
              {/* Service Details */}
              {orderDetails && orderDetails.length > 0 ? (
                <>
                  {orderDetails.map((category) => {
                    return (
                      <div key={category.id}>
                        <div
                          className="category-item d-flex justify-content-between align-items-center my-3 px-3 py-2 rounded-2"
                          style={{
                            backgroundColor: category.background_color,
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <button
                              className="btn p-0 my-0"
                              onClick={() => toggleCategoryDetails(category.id)}
                            >
                              <i
                                className={`fa-solid fa-chevron-${
                                  openCategory === category.id ? "up" : "down"
                                }`}
                              ></i>
                            </button>
                            <div className=" fw-bolder my-0 mx-3 d-flex justify-content-center align-items-center">
                              <p>{formatNumber(category.price)}</p>
                              <p className="mx-2">EGP</p>
                            </div>
                          </div>
                          <div className="d-flex justify-content-end align-items-center my-0 category-info w-25">
                            <p className="mx-2 my-0 fw-semibold fs-5">
                              {category.name}
                            </p>
                            <img
                              src={
                                category.icon_url?.startsWith("http")
                                  ? category.icon_url
                                  : `${baseUrl}${category.icon_url}`
                              }
                              className="category-icon"
                              alt={category.name}
                            />
                          </div>
                        </div>
                        {openCategory === category.id && (
                          <div
                            className="category-subcategory-container p-3"
                            style={{ backgroundColor: "#f8f8f8" }}
                          >
                            {(() => {
                              const isOtherServices =
                                category.slug === "other_services";

                              const isMaintainance =
                                category.slug === "maintainance";

                              const dataToRender = isOtherServices
                                ? category.items
                                : category.subcategories;

                              return dataToRender.map((item) => {
                                if (isOtherServices) {
                                  return (
                                    <div
                                      key={item.id}
                                      className="subcategory-item m-2"
                                    >
                                      <div className="subcategory-header mb-3 d-flex justify-content-between align-items-center">
                                        <p className="fw-bold">
                                          {formatNumber(item.final_price)} EGP
                                        </p>
                                        <p className="fw-semibold fs-4 text-muted">
                                          {item.service_name}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                }
                                if (isMaintainance) {
                                  const subcategory = item;
                                  return (
                                    <div
                                      key={subcategory.id}
                                      className="subcategory-item m-2"
                                    >
                                      <div className="subcategory-header mb-3 d-flex justify-content-between align-items-center">
                                        <p className="fw-bold">
                                          {formatNumber(subcategory.price)}
                                        </p>
                                        <p className="fw-semibold fs-5 text-muted">
                                          {subcategory.name}
                                        </p>
                                      </div>
                                      {/* اسم العرض */}
                                      {subcategory.selected_offer && (
                                        <p className="fw-semibold text-dark text-end">
                                          {subcategory.selected_offer.name}
                                        </p>
                                      )}
                                      {/* زر التفاصيل */}
                                      <p
                                        className="text-black text-decoration-underline text-end"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          console.log("clicked", subcategory);
                                          openMaintainanceModal(subcategory);
                                        }}
                                      >
                                        View Details
                                      </p>
                                    </div>
                                  );
                                }
                                const subcategory = item;
                                const hasServices =
                                  subcategory.items &&
                                  subcategory.items.length > 0;
                                const hasOffers =
                                  subcategory.offers &&
                                  subcategory.offers.length > 0;
                                const isChangeSubcategory =
                                  subcategory.slug?.startsWith("change_");
                                return (
                                  <div
                                    key={subcategory.id}
                                    className="subcategory-item m-2"
                                  >
                                    <div className="subcategory-header mb-3 d-flex justify-content-between align-items-center">
                                      <p className="fw-semibold fs-4 text-muted">
                                        {subcategory.total_price !==
                                          undefined &&
                                        subcategory.total_price !==
                                          subcategory.price ? (
                                          <>
                                            <span>
                                              {formatNumber(subcategory.price)}{" "}
                                              EGP
                                            </span>
                                            <span
                                              className="ms-3"
                                              style={{
                                                color: "#A80101",
                                                textDecoration: "line-through",
                                              }}
                                            >
                                              {formatNumber(
                                                subcategory.total_price,
                                              )}{" "}
                                              EGP
                                            </span>
                                          </>
                                        ) : (
                                          <span>{subcategory.price} EGP</span>
                                        )}
                                      </p>
                                      <p className="fw-semibold fs-4 text-muted">
                                        {subcategory.name}
                                      </p>
                                    </div>
                                    {hasServices && (
                                      <div className="services-wrapper bg-light rounded-2">
                                        {subcategory.items.map((service) => (
                                          <div
                                            key={service.id}
                                            className="service-item mb-3"
                                          >
                                            {!isChangeSubcategory && (
                                              <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex justify-content-between">
                                                  <p className="fw-bold">
                                                    {service.base_price !==
                                                    service.final_price ? (
                                                      <>
                                                        <span
                                                          style={{
                                                            color: "black",
                                                          }}
                                                        >
                                                          {formatNumber(
                                                            service.final_price,
                                                          )}{" "}
                                                          EGP
                                                        </span>
                                                        <span
                                                          className="ms-3"
                                                          style={{
                                                            color: "#A80101",
                                                            textDecoration:
                                                              "line-through",
                                                          }}
                                                        >
                                                          {formatNumber(
                                                            service.base_price,
                                                          )}{" "}
                                                          EGP
                                                        </span>
                                                      </>
                                                    ) : (
                                                      <span>
                                                        {formatNumber(
                                                          service.final_price,
                                                        )}{" "}
                                                        EGP
                                                      </span>
                                                    )}
                                                  </p>
                                                </div>
                                                <p className="fs-5 fw-semibold text-muted">
                                                  {service.service_name}
                                                </p>
                                              </div>
                                            )}
                                            {/* Products or Included Items */}
                                            {(service.products?.length > 0 ||
                                              service.included_items?.length >
                                                0) && (
                                              <div className="mt-2 mb-0">
                                                {(service.products?.length > 0
                                                  ? service.products
                                                  : service.included_items
                                                ).map((item, idx) => (
                                                  <div
                                                    key={idx}
                                                    className="row d-flex justify-content-between align-items-center mt-1"
                                                  >
                                                    <div className="col-2">
                                                      <p className="fw-bold">
                                                        {formatNumber(
                                                          item.total_price,
                                                        )}{" "}
                                                        EGP
                                                      </p>
                                                    </div>
                                                    <div className="col-2">
                                                      <p className="fs-5 fw-semibold text-muted">
                                                        x{item.quantity}
                                                      </p>
                                                    </div>
                                                    <div className="col-3">
                                                      {item.price !==
                                                        undefined &&
                                                      item.price !==
                                                        item.total_price ? (
                                                        <>
                                                          <p
                                                            className="fw-bold mb-0"
                                                            style={{
                                                              color: "#A80101",
                                                              textDecoration:
                                                                "line-through",
                                                            }}
                                                          >
                                                            {formatNumber(
                                                              item.price,
                                                            )}{" "}
                                                            EGP
                                                          </p>
                                                        </>
                                                      ) : (
                                                        <p className="fs-5 fw-semibold text-muted">
                                                          {formatNumber(
                                                            item.unit_price,
                                                          )}{" "}
                                                          EGP
                                                        </p>
                                                      )}
                                                    </div>
                                                    <div className="col-5 text-end">
                                                      <p className="fs-5 fw-semibold text-muted">
                                                        {item.name}
                                                      </p>
                                                    </div>
                                                  </div>
                                                ))}
                                                {/* service_only_price */}
                                                {service.service_only_price !==
                                                  0 && (
                                                  <div className="row d-flex justify-content-between align-items-center mt-2 ">
                                                    <div className="col-2">
                                                      <p className="fw-bold">
                                                        {formatNumber(
                                                          service.service_price_total,
                                                        )}{" "}
                                                        EGP
                                                      </p>
                                                    </div>
                                                    <div className="col-10 text-end">
                                                      <p className="fs-5 fw-semibold text-muted">
                                                        سعر الخدمة
                                                      </p>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                    {hasOffers && (
                                      <div className="offers-list bg-light rounded-2">
                                        {subcategory.offers.map((offer) => (
                                          <div
                                            key={offer.id}
                                            className="offer-item mb-3"
                                            style={{
                                              borderBottom: "1px solid #ddd",
                                              paddingBottom: "10px",
                                            }}
                                          >
                                            <div className=" d-flex justify-content-between align-items-center">
                                              <div className=" d-flex">
                                                <p className="fw-bold">
                                                  {formatNumber(
                                                    offer.offer_price,
                                                  )}{" "}
                                                  EGP
                                                </p>
                                              </div>
                                              <p className="fs-5 fw-semibold text-muted">
                                                {offer.name}
                                              </p>
                                            </div>
                                            <p className="fs-6 text-muted text-end">
                                              {offer.description}
                                            </p>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                );
                              });
                            })()}
                          </div>
                        )}
                      </div>
                    );
                  })}
                  <OrderPricingSummary pricing={order?.pricing_summary} />
                </>
              ) : (
                <NotFound
                  paragraphText={
                    "No Services yet. All your Services will appear here once you get started."
                  }
                />
              )}
            </div>
          </div>
          <SideOrderDetails />
        </div>
      </div>
    </>
  );
}

/* TireCheckDetailseModal  */

/* {isTireCheckDetailsModalOpen && (
        <div
          className="modal fade show Tire-check-details"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div
            className="modal-dialog orderDetails-modal"
            style={{ maxWidth: "35%" }}
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header orderDetails-modalHeader px-4 bg-secondary bg-opacity-10 ">
                <i
                  onClick={() => toggleTireCheckDetailsModal()}
                  className="fa-solid fa-xmark fa-xl cursor"
                ></i>
                <p
                  className="modal-title orderDetails-modalTitle mx-auto my-0 fs-5 fw-semibold"
                  id="exampleModalLabel"
                >
                  عرض الفحص الشامل للكاوتش
                </p>
              </div>
              <div className="modal-body orderDetails-modalBody p-3 text-end">
                <h5> : يشتمل العرض علي </h5>
                <p>
                  لحام 2 ثقب , ملئ نيتروجين , ترصيص 20 جرام , تبديل موضع
                  الاطارات
                </p>
                <div className="d-flex justify-content-between fw-bold">
                  <p> ج.م 280.0</p>
                  <p> : السعر </p>
                </div>
                <h5> : وما زاد عن ذلك كالتالي </h5>
                <p className="fw-semibold my-2 ">
                  اسعار اللحام (في حالة وجود ثقوب)
                </p>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className="d-flex align-items-center justify-content-between"
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0 ">15.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-0 mx-2  text-muted"> لحام خابور </p>
                    <i className="fa-solid fa-circle fa-2xs text-muted"></i>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0 ">50.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-0 mx-2 text-muted"> لحام داخلي صغير </p>
                    <i className="fa-solid fa-circle fa-2xs text-muted"></i>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between  "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0 ">80.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-0 mx-2 text-muted"> لحام داخلي كبير </p>
                    <i className="fa-solid fa-circle fa-2xs text-muted"></i>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className="d-flex align-items-center justify-content-between  "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0">120.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-0 mx-2 text-muted"> لحام حقن مطاط </p>
                    <i className="fa-solid fa-circle fa-2xs text-muted"></i>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0 ">15.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-1 fw-semibold ">
                      ملئ نيتروجين (لكل كاوتش)
                    </p>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0">5.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-1 fw-semibold ">اسعار الترصيص (5 جرام)</p>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between"
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0">400.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-1 fw-semibold ">
                      اسعار استعدال الجنوط (لكل كاوتش)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */

/* TirePriceDetailseModal  */

/* {isTirePriceDetailsModalOpen && (
        <div
          className="modal fade show Tire-check-details"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: "block" }}
        >
          <div
            className="modal-dialog orderDetails-modal"
            style={{ maxWidth: "35%" }}
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header orderDetails-modalHeader px-4 bg-secondary bg-opacity-10 ">
                <i
                  onClick={() => toggleTirePriceDetailsModal()}
                  className="fa-solid fa-xmark fa-xl cursor"
                ></i>
                <p
                  className="modal-title orderDetails-modalTitle mx-auto my-0 fs-5 fw-semibold"
                  id="exampleModalLabel"
                >
                  اسعار تحدد عند الزياره
                </p>
              </div>
              <div className="modal-body orderDetails-modalBody p-3 text-end">
                <p className="fw-semibold my-2 ">
                  اسعار اللحام (في حالة وجود ثقوب)
                </p>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className="d-flex align-items-center justify-content-between"
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0 ">15.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-0 mx-2  text-muted"> لحام خابور </p>
                    <i className="fa-solid fa-circle fa-2xs text-muted"></i>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0 ">50.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-0 mx-2 text-muted"> لحام داخلي صغير </p>
                    <i className="fa-solid fa-circle fa-2xs text-muted"></i>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between  "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0 ">80.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-0 mx-2 text-muted"> لحام داخلي كبير </p>
                    <i className="fa-solid fa-circle fa-2xs text-muted"></i>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className="d-flex align-items-center justify-content-between  "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0">120.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-0 mx-2 text-muted"> لحام حقن مطاط </p>
                    <i className="fa-solid fa-circle fa-2xs text-muted"></i>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0 ">15.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-1 fw-semibold ">
                      ملئ نيتروجين (لكل كاوتش)
                    </p>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between "
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0">5.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-1 fw-semibold ">اسعار الترصيص (5 جرام)</p>
                  </div>
                </div>
                <div className=" d-flex justify-content-between align-items-center">
                  <div
                    style={{ width: "20%" }}
                    className=" d-flex align-items-center justify-content-between"
                  >
                    <p className=" my-0">ج.م</p>
                    <p className=" my-0">400.0</p>
                  </div>
                  <div className=" d-flex align-items-center">
                    <p className=" my-1 fw-semibold ">
                      اسعار استعدال الجنوط (لكل كاوتش)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */
